import React, {useEffect} from 'react';
import {logPageLoadEvents} from '@ibibo/analytics';
import {useSelector, useDispatch} from 'react-redux';
import {userDataSelector, prevPageNameSelector, mpnfoSelector} from '../../store/selectors';
import {updatePreviousPageName} from '../../store/actions'
import OnboardingNew from '../../stories/components/OnboardingNew/OnboardingNew';
import MmtUserLogin from './containers/MmtLogin';

const MmtLogin = () => {
    const userInfo = useSelector(userDataSelector);
    const { email, mobile, requestIp, accountId } = userInfo;
    const data = useSelector(prevPageNameSelector);
    const mpnfoValue = useSelector(mpnfoSelector);
    const {prevPageName} = data;
    const dispatch = useDispatch();
    
    useEffect(() => {
        const events = {
            eVar34: email,
            eVar35: mobile,
            eVar23: prevPageName,
            eVar28: requestIp,
            eVar67: accountId,
            eVar24: "onboarding|mypartner",
            eVar37: "domain_sbu:india|domain_country:in|domain_currency:inr|domain_language:eng",
            eVar107: `mpnfo_${mpnfoValue}`,
        }
        logPageLoadEvents('onboarding:mmtUserLogin', events);
        dispatch(updatePreviousPageName("onboarding:mmtUserLogin"));
  }, [dispatch]);

    return(
        <OnboardingNew step={3}>
            <MmtUserLogin />
        </OnboardingNew>
    )
}

export default MmtLogin